import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { FormulareServiceModule } from '..';
import { FormulareSorterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    FormulareServiceModule
  ],
  declarations: [FormulareSorterComponent],
  exports: [FormulareSorterComponent],

})
export class FormulareSorterComponentModule { }
